<template>
  <div class="text-center">
    <p class="h5">Loading {{ topic }}...</p>
    <img src="/assets/loading.gif" />
  </div>
</template>

<script>
export default {
  props: {
    topic: { type: String, default: "" }
  }
}
</script>